import Done from "@mui/icons-material/Done";
import Button from "components/Button";
import { isTrue } from "helpers/utils/validators";
import React from "react";

const ProjectCTA = ({
  project,
  setAssessmentModelOpen,
  setSubmissionOpen,
  isDueDatePassed,
  challengeStatusClosed,
  t = (d) => d,
}) => {
  // DETERMINE IF THE PROJECT HAS BEEN SUBMITTED
  const isProjectSubmitted = isTrue(project?.is_submitted);

  // DETERMINE IF THE PROJECT HAS BEEN ASSESSED
  const isProjectAssessed = project?.is_view_assess_enabled === "yes";

  // CHECK IF SUBMISSION IS NOT ALLOWED BASED ON CHALLENGE SETTINGS
  const submissionNotAllowed =
    project?.challenge_details?.submission_status === "not_allowed";

  // TOOLTIP TITLE BASED ON SUBMISSION AND CHALLENGE STATE
  const tooltipTitle = t(
    isDueDatePassed && !isProjectSubmitted
      ? "Late submission"
      : challengeStatusClosed
      ? "Challenge closed for submission"
      : !isProjectSubmitted
      ? "Project is not submitted yet."
      : submissionNotAllowed
      ? "Submission is not allowed."
      : ""
  );

  // DETERMINE IF MAIN BUTTON SHOULD BE DISABLED
  const isButtonDisabled =
    (isProjectSubmitted && !isProjectAssessed) ||
    (submissionNotAllowed && !isProjectSubmitted) ||
    !isTrue(project?.submit_enabled) ||
    challengeStatusClosed;

  // DETERMINE BUTTON COLOR BASED ON SUBMISSION/ASSESSMENT STATE
  const buttonColor = isButtonDisabled
    ? "gray"
    : isProjectSubmitted && !isTrue(project?.is_assess_enabled)
    ? "green"
    : isProjectSubmitted && !isProjectAssessed
    ? "orange"
    : "green";

  // RENDER THE BUTTON LABEL BASED ON PROJECT STATE
  const renderButtonLabel = () => {
    // CASE: VIEW ASSESSMENT
    if (
      isProjectAssessed &&
      isProjectSubmitted &&
      project?.joined_status === "accepted"
    ) {
      return (
        <>
          <Done /> {t("View Assessment")}
        </>
      );
    }

    // CASE: ALREADY SUBMITTED BUT NO ASSESSMENT NEEDED
    if (
      isProjectSubmitted &&
      project?.project_role === "submitter" &&
      project?.assessment_data?.assessment_type === "none" &&
      project?.joined_status === "accepted"
    ) {
      return (
        <>
          <Done /> {t("Submitted")}
        </>
      );
    }

    // CASE: PENDING ASSESSMENT BY SUBMITTER
    if (
      !isProjectAssessed &&
      isTrue(project?.is_assess_enabled) &&
      isProjectSubmitted &&
      project?.project_role === "submitter" &&
      project?.assessment_data?.assessment_type !== "none"
    ) {
      return t("Pending Assessment");
    }

    // CASE: READY FOR SUBMISSION
    if (
      (!isProjectAssessed && !isProjectSubmitted && !isDueDatePassed) ||
      submissionNotAllowed
    ) {
      return <>{t("Submit Project")}</>;
    }

    // CASE: LATE SUBMISSION
    return (
      isDueDatePassed &&
      !isProjectSubmitted &&
      !isProjectAssessed &&
      t("Late submission")
    );
  };

  return (
    <span className="w-60p">
      <Button
        classes="fs-15"
        color={buttonColor}
        width="100%"
        height="40px"
        tooltip={tooltipTitle}
        onClick={() => {
          // HANDLE BUTTON CLICK BASED ON PROJECT STATE
          if (isButtonDisabled) return;
          if (isTrue(isProjectSubmitted) && isProjectAssessed) {
            setAssessmentModelOpen(true);
          } else {
            setSubmissionOpen(true);
          }
        }}
      >
        {renderButtonLabel()}
      </Button>
    </span>
  );
};

export default ProjectCTA;
